import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../../modules/authentication/services/authentication.service';
import { PipesModule } from '../../modules/pipes/pipes.module';
import { SharedService } from '../../modules/shared/services/shared.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [CommonModule, PipesModule],
})
export class FooterComponent implements OnInit {
  constructor(
    public authenticationService: AuthenticationService,
    public sharedService: SharedService,
  ) {}

  ngOnInit(): void {}
}
